export default "__VITE_ASSET__DbLEAXzt__"